<div class="container-fluid">
    <div class="row justify-content-between manageaccount mt-3">
        <div class="col-xl-12">
            <div class="d-flex align-items-center justify-content-between">
                <h1 class="fs-4 fw-bold">Cash Dispense Report : {{month}} {{year}}</h1>
                <button class="btn btn-dark btn-sm " mat-raised-button matTooltip="Back" matTooltipPosition="left"
                    (click)="backTo()"><i class="fa-solid fa-arrow-left"></i></button>
            </div>
        </div>

    </div>


    <div class="contentbox mt-3">
        <div class="row customepadding">
            <div class="col-md-12 table-responsive ">
                <table datatable class="row-border hover tablelist" *ngIf='dispenseArray.length > 0 '>
                    <thead>
                        <tr>
                            <td>Supervisor Name</td>
                            <td>Company Name</td>
                            <!-- <td>Account Holder</td> -->
                            <td>Amount</td>
                            <td>Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user1 of dispenseArray">
                            <td [routerLink]="['../../../dateWiseDispense/', paramId, user1.companyId, user1.supervisorId, this.year]">{{user1.SupervisorName}}</td>
                            <!-- <td>{{user1.companyName}}</td> -->
                            <td [routerLink]="['../../../dateWiseDispense', paramId, user1.companyId, user1.supervisorId, this.year]">{{user1.companyName}}</td>
                            <td [routerLink]="['../../../dateWiseDispense', paramId, user1.companyId, user1.supervisorId, this.year]">{{user1.amount}}</td>
                            <td [routerLink]="['../../../dateWiseDispense', paramId, user1.companyId, user1.supervisorId, this.year]">view</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>